import React, { Component } from "react";
import { Button, Radio,Icon, TextareaItem,TabBar, Toast,InputItem,List,Picker,Modal,DatePicker } from "antd-mobile";
import "./Home.scss";
import moment from "moment";
import qs from "qs";
import http from "../../util/api";
import { zhaotongTownship } from "../../util/zhaotongTownship";
import { zhaotongCommunity } from "../../util/zhaotongCommunity";
import {nation} from "../../util/nation";
const Antalert = Modal.alert;
let player;
export default class Home extends Component {
  state = {
    selectedTab: "home",
    hidden: false,
    page:-1,
    companies:[
    ],
    loading:true,
    userInfo:{},
    showDetail:false,
    toSub:[{job:'',salary:'',jobId:''}],
    toDel:[],
    currentEnterprise:{
      activatedRules:'',
      enterpriseName:'',
      introduction:'',
      logo:'',
      vid:'',
      692791411354:[],
    },
    jobFair:{},
    canAttend:null,
    futureJobFair:[],
    kw:undefined,
    histories:[],
    curTownship:[],
    curExp:{},
    showExp:false,
    reLoaded:false,
    isSHG:false
  };
//sampleLink:http://localhost:3000/?enterpriseID=693079499444&jobID=693080455532
//enterpriseID：企业编号，jobID：职位编号

  componentDidMount = () => {
    this.getPersonalInfo();
    player = window.TCPlayer("player-container-id", { // player-container-id 为播放器容器ID，必须与html中一致
      fileID: '5285890800005441046', // 请传入需要播放的视频fileID 必须
      appID: "", // 请传入点播账号的appID 必须
      autoplay: false, //是否自动播放
      plugins:{
        ContinuePlay: { // 开启续播功能
          auto: true, //[可选] 是否在视频播放后自动续播
          text:'上次播放至 ', //[可选] 提示文案
          btnText: '恢复播放' //[可选] 按钮文案
        },
      },
     
  });
   
  };
  clearVideo=()=>{
    this.refs.video.pause()
    // player.loadVideoByID({
    //   fileID: '', // 请传入需要播放的视频 filID（必须）
    //   appID:  '', // 请传入点播账号的 appID（必须）
    // });
  }
  memo=()=>{
  }
  onChangeWkExp=(v,name,type)=>{
    let obj=this.state.curExp;
    if(type==='input'){
      obj[name]=v
    }else if(type==='select'){
      obj[name]=v[0];
    }else if(type==='date'){
     obj[name]=v;
    }
    this.setState({curExp:obj});
  }
  fixIOSWXBug() {
    document.body.scrollTop = 0;
  }
  getHistories=async(v)=>{
    Toast.loading();
    try{
      const res = await http().getTable({
        resid:692384358878
      });
      let arr = [];
      if(res.data){
        if(res.data.data){
          let n =0;
          while(n<res.data.data.length){
            if(n==0){
              arr.push({date:res.data.data[n].createDate,children:[res.data.data[n]]});
            }else{
              let bol=false;
              let c=0;
              while(c<arr.length){
                if(res.data.data[n].createDate===arr[c].date){
                  let a = arr[c].children;
                  a.push(res.data.data[n]);
                  arr[c].children=a;
                  bol=true;
                }
                c++;
              }
              if(!bol){
                arr.push({date:res.data.data[n].createDate,children:[res.data.data[n]]});
              }
            }
            n++;
          }
          this.setState({histories:arr});
        }
      }
      if(v){
        Toast.success('撤销成功',1);
      }else{
        Toast.hide();
      }
    }catch(e){
      Toast.info(e.message);
    }
  }
  getJobFair=async()=>{
    try{
      const res = await http().getTable({
        resid:692804958721
      });
      if(res.data){
        if(res.data.data.length>0){
          this.setState({jobFair:res.data.data[0]});
          let myTime=new Date();
          myTime=moment(myTime);
          let n=0;
          let bol=false;
          let arr=[];
          while(n<res.data.data.length){
            if(moment(res.data.data[n].stTime)>myTime){
              arr.push(res.data.data[n]);
            }
            if(myTime>moment(res.data.data[n].stTime)&&myTime<moment(res.data.data[n].edTime)){
              this.setState({canAttend:true,curFairId:res.data.data[n].recid});
              bol=true
            }
            n++;
          }
          this.setState({futureJobFair:arr});
          if(bol){
            return true;
          }else{
            return false;
          }
        }
      }else{
        return false
      }
      
    }catch(e){
      Toast.info(e.message);
    }
  }
  getCompany=async(c,k,re,personInfo,e,ee,jobID,j)=>{
    //c:上下翻页获取新数据
    //k:关键字
    //re:是否从头开始获取数据
    //personInfo:个人信息
    //e:是否进入详情页
    //ee:是否进入详情页错误
    //jobId:投递简历
    //j:是否跳转企业列表
    Toast.loading();
    this.setState({loading:true});
    let p = this.state.page;
    p=p+1;
    this.setState({page:p});
    let kw =this.state.kw;
    let arr = this.state.companies;
    if(re){
      kw=k;
      p=0;
      arr=[];
      this.setState({page:0});
    }
    try{
      const res = await http().getRecordAndSubTables({
        resid:692791348405,
        subresid:692791411354,
        getsubresource: 1,
        pageindex:p,
        pageSize:10,
        key:kw
      });
      let n =0;
      while(n<res.data.data.length){
        arr.push(res.data.data[n])
        n++;
      }
      this.setState({companies:arr,total:res.data.total,loading:false});
      if(c){
        this.setState({currentEnterprise:arr[c],toSub:[{jobId:'',enterpriseId:'',jobFairId:'',job:'',salary:''}]});
        if(arr[c].vid){
          player.loadVideoByID({
            fileID: arr[c].vid, // 请传入需要播放的视频 filID（必须）
            appID:  "1253458086", // 请传入点播账号的 appID（必须）
          });
        }else{
          this.clearVideo();
        }
      }
      if(e){
        if(res.data.data.length>0){
          this.setState({
            showDetail:true,
            reLoaded:true,
            currentEnterprise:res.data.data[0]
          })
          if(res.data.data[0].vid){
            player.loadVideoByID({
              fileID: res.data.data[0].vid, // 请传入需要播放的视频 filID（必须）
              appID:  "1253458086", // 请传入点播账号的 appID（必须）
            });
          }else{
          this.clearVideo();
          }
          if(j){
            this.setState({selectedTab: "home"});
          }
              if(jobID){
                let b = this.vertify(false,personInfo);
                if(!b){
                  this.setState({selectedTab:'personal_center',showDetail:false});
                    // Toast.info('请先填写完整个人信息',1);
                }else{
                  let cc=0;
                  let obj={REC_ID:null}
                  while(cc<res.data.data[0][692791411354].length){
                    if(res.data.data[0][692791411354][cc].recid===jobID){
                      obj=res.data.data[0][692791411354][cc];
                    }
                    cc++;
                  }
                  if(obj.REC_ID){
                      Toast.hide();
                      Antalert("确认申请该职位？", <div className="memo">
                      <p>{this.state.toSub[0].job+'- 工资：'+this.state.toSub[0].salary}</p>
                      <div>
                      <span>有何建议和需求：</span><TextareaItem value={this.state.advice} onChange={(v)=>{this.setState({advice:v})}}/>
                      </div>
                      <div>
                       <span>备注：</span> <TextareaItem value={this.state.memo} onChange={(v)=>{this.setState({memo:v})}}/>
                      </div>
                    </div>, [
                        { text: "取消", onPress: () => {} },
                        {
                          text: "确认",
                          onPress: () => this.handleSubmit(obj)
                        }
                      ]);
                  }else{
                    Toast.fail('职位信息有误',1);
                  }
                }
              }else{
                Toast.hide();
              }
          
        }else{
          Toast.fail('未找到企业信息',1);
          this.getCompany(null,'',true,null,null,true);
        }
      }else{
        if(ee){
          Toast.info('未找到对应的企业',1);
        }else{
          Toast.hide();
        }
      }
      
    }catch(e){
      Toast.info(e.message);
    }
  }
  getPersonalInfo=async(j)=>{
    const search = document.location.search;
    const querystring = search.substring(1);
    const {enterpriseID,jobID,isSHG} = qs.parse(querystring);
    if(isSHG){
      this.setState({isSHG:true,selectedTab: "personal_center"});
    }
    let phone=localStorage.getItem('userInfo');
    if(!phone){
      if(isSHG){
        this.props.history.push('/login?isSHG=1');
        Toast.info('请先登录/注册',1);
        return false
      }
      this.props.history.push("/login"+(enterpriseID?('?enterpriseID='+enterpriseID):'')+(jobID?('&jobID='+jobID):''));
      Toast.info('请先登录/注册',1);
     
      return false
    }else{
      phone = JSON.parse(phone);
      if(!phone.UserInfo){
        if(isSHG){
          this.props.history.push('/login?isSHG=1');
          Toast.info('请先登录/注册',1);
          return false
        }
        this.props.history.push("/login"+(enterpriseID?('?enterpriseID='+enterpriseID):'')+(jobID?('&jobID='+jobID):''));
        Toast.info('请先登录/注册',1);
      
        return false
      }
      phone = phone.UserInfo.EMP_HANDPHONE;
      if(!phone){
        if(isSHG){
          this.props.history.push('/login?isSHG=1');
          Toast.info('请先登录/注册',1);
          return false
        }
        this.props.history.push("/login"+(enterpriseID?('?enterpriseID='+enterpriseID):'')+(jobID?('&jobID='+jobID):''));
        Toast.info('请先登录/注册',1);
      
         return false
      }
    }
    Toast.loading();

    let canAttend = await this.getJobFair();
    try{
      let res = await http().getTable({
        resid:692558819745
      });
      if(res.data.data.length>0){
        this.setState({orgInfo:res.data.data[0],userInfo:res.data.data[0]});
        if(res.data.data[0].township){
          this.selectTownship([res.data.data[0].township],true);
        }
       
        let p=null;
        if(jobID){
          p=res.data.data[0];
        }
        this.getCompany(null,enterpriseID,enterpriseID?true:false,p,enterpriseID?true:false,null,jobID,j);
      }else{
        Toast.info('请先登录/注册',1);
        if(isSHG){
          this.props.history.push('/login?isSHG=1');
          Toast.info('请先登录/注册',1);
          return false
        }
        this.props.history.push("/login"+(enterpriseID?('?enterpriseID='+enterpriseID):'')+(jobID?('&jobID='+jobID):''));
         return false
      }
      if(isSHG){
          let res2 = await http().getTable({
            resid:692902751953
          });
          if(res2.data){
            if(res2.data.data.length>0){
              let oo=res2.data.data[0];
                  oo.enterDate=moment(res2.data.data[0].enterDate).toDate();
              this.setState({curExp:oo});
            }else{
              this.setState({curExp:{enterDate:undefined}});

            }
          }}
          }catch(e){
        Toast.info(e.message);
        }
  }
  vertify=(v,o)=>{
    let obj=this.state.orgInfo;
    if(v){
      obj=this.state.userInfo;
    }
    if(o){
      obj=o;
    }
    if(!obj.name){
      Toast.fail('“姓名”未填写',1);
      return false;
    }
    else if(!obj.sex){
      Toast.fail('“性别”未填写',1);
      return false;
    }
    else if(!obj.ID){
      Toast.fail('“身份证号”未填写',1);
      return false;
    }
    else if(!obj.nation){
      Toast.fail('“民族”未填写',1);
      return false;
    }
    else if(!obj.education){
      Toast.fail('“学历”未填写',1);
      return false;
    }
    else if(!obj.township&&!v){
      Toast.fail('“户籍所在县、乡镇”未填写',1);
      return false;
    }
    else if(!obj.township_semi&&v){
      Toast.fail('“户籍所在县、乡镇”未填写',1);
      return false;
    }
    else if(obj.township_semi==='其他'&& !obj.township){
      Toast.fail('“户籍所在县、乡镇”未填写',1);
      return false;
    }
    else if(!obj.community){
      Toast.fail('“村/社区”未填写',1);
      return false;
    }
    else if(!obj.inFile){
      Toast.fail('“是否建档脱贫人员”未填写',1);
      return false;
    }else{
      return true
    }
  }
  subPersonInfo=async()=>{
    
    if(this.state.isSHG){
      let bol2 = this.vertifyWk();
      if(!bol2){
        return false;
      }
    }else{
      let bol =this.vertify(true);
      if(!bol){
        return false;
      }
    }
    Toast.loading();
    let res
    try{
      if(this.state.isSHG){
        //主子表
        let obj = this.state.userInfo;
        obj._state='editoradd';
        obj._id=1;
        let obj2=this.state.curExp;
        obj2._state='editoradd';
        obj2._id=1;
        let sub=[
          {resid: '692902751953',
            maindata: obj2}
        ]
        res = await http().saveRecordAndSubTables({
          data: [
            {
              resid: '692558819745',
              maindata: obj,
              subdata:sub
            }
          ]
        });
      }else{
        let objInfo=this.state.userInfo;
        if(objInfo.township_semi!='其他'){
          objInfo.township=objInfo.township_semi;
        }
        res = await http().modifyRecords({
          resid:692558819745,
          data:[objInfo]
        });
      }
      const search = document.location.search;
      const querystring = search.substring(1);
      const {enterpriseID,jobID} = qs.parse(querystring);
      if(enterpriseID){
        this.setState({orgInfo:res.data.data[0]});
        this.getPersonalInfo(true);
      }else{
        this.setState({orgInfo:res.data.data[0]});
        Toast.success('保存成功',1);
      }

    }catch(e){
      Toast.info(e.message);
    }
  }
  enterDetail=(v)=>{
    let bol = this.vertify();
    if(!bol){
      this.setState({selectedTab:'personal_center'});
    }else{
      Toast.hide();
      this.setState({
        showDetail:true,
        currentEnterprise:v
      })
      Toast.loading('',1);
      if(v.vid){
        player.loadVideoByID({
          fileID: v.vid, // 请传入需要播放的视频 filID（必须）
          appID:  "1253458086", // 请传入点播账号的 appID（必须）
        });
      }else{
        this.clearVideo();
      }
    }
  }
  enterWkExp=async(v)=>{
    this.setState({curExp:0});
    let bol = this.vertify();
    if((!bol)&&(!v)){
      this.setState({selectedTab:'personal_center'});
    }else{
    Toast.loading();
      try{
        let res = await http().getTable({
          resid:692902751953
        });
        if(res.data){
          if(res.data.data.length>0){
            let n = 0;
            let arr=[]
            while(n<res.data.data.length){
              let obj=res.data.data[n];
              if(obj.enterDate){
                obj.enterDate=moment(res.data.data[n].enterDate).toDate();
              }
              arr.push(obj)
              n++;
            }
            this.setState({wkExp:arr});
          }else{
            if(v){
            this.setState({wkExp:[]});
            }
          }
        }
        this.setState({
          selectedTab: "work_exp",
          showDetail:false,
          showExp:false
        });
        if(v){
          Toast.success('成功',1);
        }else{
          Toast.hide();
        }
      }catch(e){
      Toast.info(e.message);
      }
    }
  }
  handleSubmit=async(obj)=>{
    Toast.loading();
    let arr=this.state.toSub;
    if(obj){
      let o=obj;
      o.jobId=o.REC_ID;
      o.memo=this.state.memo;
      o.advice=this.state.advice;
      arr=[o]
    }
    let n =0;
    while(n<arr.length){
      arr[n].jobFairId=this.state.curFairId;
      arr[n].memo=this.state.memo;
      arr[n].advice=this.state.advice;
      arr[n].memberId=this.state.userInfo.recid;
      n++;
    }
    this.setState({memo:'',advice:''});
    try{
      let res = await http().addRecords({
        resid:692384358878,
        data:arr
      });
      Toast.success('保存成功',1);

    }catch(e){
        Toast.info('提交失败，同一招聘会同一人只能申请一次同一家企业的其中一个职位');
    }
  }
  handleNxt=(v)=>{
    if((this.state.companies[0].recid===this.state.currentEnterprise.recid && v==='left' )||(this.state.companies[this.state.companies.length-1].recid===this.state.currentEnterprise.recid && v==='right' && this.state.companies.length>=this.state.total)){
     
    }else{
      this.setState({enlargeImg:false});
      this.refs.companyDetails.scroll(0, 0);
      let curId=this.state.currentEnterprise.recid;
      let n = 0;
      let a =this.state.companies;
      let c=0;
      let bol=false;
      Toast.loading('',1);
      while(n<a.length){
        if(a[n].recid===curId){
          if(v==='right'){
            c=n+1;
            if(a[a.length-1].recid===curId){
              bol=true;
              this.getCompany(c);
            }
          }else{
            c=n-1;
          }
        }
        n++;
      }
      if(!bol){
        this.setState({
          currentEnterprise:this.state.companies[c], toSub:[{jobId:'',enterpriseId:'',jobFairId:''}]
        })
        if(this.state.companies[c].vid){
          player.loadVideoByID({
            fileID: this.state.companies[c].vid, // 请传入需要播放的视频 filID（必须）
            appID:  "1253458086", // 请传入点播账号的 appID（必须）
          });
        }else{
          this.clearVideo();
        }
      }
    }
  }
  getSearchTxt=(e,v)=>{
    e.preventDefault();
    this.getCompany(null,v,true);
  }
  handleCancel=async(recid)=>{
    Toast.loading();
    try{
      const res = await http().modifyRecords({
        resid:692384358878,
        data:[{REC_ID:recid,canceled:'Y'}]
      });
      this.getHistories(1);
    }catch(e){
      Toast.info(e.message);
    }
  }
  selectTownship=(v,bol)=>{
      let n =0;
      let token='';
      let isOther=true;
      while(n<zhaotongTownship.length){
        if(zhaotongTownship[n].value===v[0]){
          token=zhaotongTownship[n].token;
          isOther=false;
        }
        n++;
      }
      n=0;
      while(n<zhaotongCommunity.length){
        if(zhaotongCommunity[n].parentToken===token){
          this.setState({curTownship:zhaotongCommunity[n].children});
        }
        n++;
      }
      if(bol){
        if(isOther){
          let o=this.state.userInfo;
          o.township_semi='其他';
          o.township=v[0];
          this.setState(
            { userInfo: o,orgInfo: o },
          );
        }else{
          this.setState(
            { userInfo: { ...this.state.userInfo, township_semi: v[0] } },
          );
        }
        
      }else{
        this.setState(
          { userInfo: { ...this.state.userInfo, township_semi: v[0] , community: ''} },
        );
      }
  }
  vertifyWk=()=>{
    let n=0;
    let obj=this.state.curExp;
    let compare=[
      {
        label:'enterpriseName',
        val:'企业名'
      },{
        label:'enterpriseAddress',
        val:'企业地址'
      },{
        label:'enterpriseHR',
        val:'企业联系人(职务)'
      },{
        label:'enterprisePhone',
        val:'企业联系人手机'
      }
    ]
      let c=0;
      while(c<compare.length){
        if(!obj[compare[c].label]){
          Toast.fail('“'+compare[c].val+'”未填写。',1)
          return false;
        }
        c++;
      }
      return true;
  }
 
  delWkExp=async()=>{
   Toast.loading();
   try{
      const res2 = await http().removeRecords({
        resid:692902751953,
        data:[{REC_ID:this.state.curExp.REC_ID}]
      });
    this.enterWkExp(true);
  }catch(e){
    Toast.info(e.message);
  }
   
  }
  addWkExp=async()=>{
    const res = await http().addRecords({
      resid:692902751953,
      data:[{memberId:this.state.userInfo.recid}],
    });
  this.enterWkExp();
  }
  changeWkExp=(v)=>{
    let curExp=this.state.curExp;
    if((v==='left'&&curExp===0) || (v==='right'&&curExp===this.state.wkExp.length-1)){
      return false;
    }else{
      if(v==='left'){
        curExp--;
      }else{
        curExp++;
      }
      this.setState({curExp});
    }
  }
  logOut=()=>{
    window.localStorage.clear();
    if(this.state.isSHG){
      this.props.history.push('/login?isSHG=1');
    }else{
    this.props.history.push('/login');
    }
  }
  render() {
    return (
      <div
        className='main_wrap'
      > 
       {
              this.state.enlargeImg?<>
              <Icon  className='clz' type='cross' onClick={()=>{this.setState({enlargeImg:false});}}/>
              <div className='enlargedImg'>
                <div>
                <img src={this.state.currentEnterprise.activatedRules}/>
                </div>
               
              </div>
              </>:null
            }
      <div ref='companyDetails' className='companyDetails' style={this.state.showDetail?{display:'block'}:{display:'none'}}>
           
            <div className='hint_move'>↑↑ 向上滑动可以查看更多详情内容与职位 ↑↑</div>
            <div className='activatedRules'>
              <img src={this.state.currentEnterprise.activatedRules} onClick={()=>{this.setState({enlargeImg:true});}}/>
            </div>
            <div className="words">
              <div className='title'>
              <div className='logo' style={this.state.currentEnterprise.logo?{backgroundImage:'url('+this.state.currentEnterprise.logo+')',backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat:'no-repeat'}:{}}>
               </div>
               <h2>
                  {this.state.currentEnterprise.enterpriseName}
                </h2>
              </div>
                <div>
                  {this.state.currentEnterprise.introduction}
                </div>
              </div>
              <div className="videOuter" ref='videoOuter' style={!this.state.currentEnterprise.vid?{display:'none'}:{}}>
              <video ref='video' id="player-container-id" style={{width:'100vw',height:'56.25vw'}} preload="none" playsInline webkit-playsinline='true'></video>
                </div>
              <ul className='jobs' ref='jobs'>
                <li><h4>请选择应聘职位：</h4></li>
                    {this.state.currentEnterprise[692791411354]?this.state.currentEnterprise[692791411354].map(item=>{
                      return(
                        <li key={item.recid}>
                        <Radio checked={this.state.toSub[0].jobId===item.recid} key={item.recid} onClick={()=>{this.setState({toSub:[{enterpriseId:this.state.currentEnterprise.recid,jobId:item.recid,job:item.job,salary:item.salary}]})}}>
                         
                        </Radio>
                        <div className='jobDetails'> 
                        <div><b>{item.job}</b>
                          </div>
                          <div>
                            工资待遇（单位：元/月）：{item.salary}
                          </div>
                          <div>招聘人数：{item.number}
                          </div>
                          <div>
                          是否提供（或安排）住宿：{item.dormitory}
                          </div>
                          <div>
                          工作地址：{item.jobAddress}
                          </div>
                        </div>
                        </li>
                      )
                    }):null}
              </ul>
              <footer>
                <div
                className='btn' 
                onClick={()=>{
                  if(this.state.reLoaded){
                    this.getCompany(null,'',true,null,null,null)
                  }
                  this.refs.companyDetails.scroll(0, 0);
                  this.setState({
                    showDetail:false,
                    reLoaded:false,
                    enlargeImg:false,
                    toSub:[{jobId:'',enterpriseId:'',jobFairId:'',job:'',salary:''}],
                    currentEnterprise:{
                      activatedRules:'',
                      enterpriseName:'',
                      introduction:'',
                      logo:'',
                      vid:'',
                      692791411354:[],
                    }
                    
                  });
                  this.clearVideo();
                }}
                >
                  返回
                </div>
                <div
                className={this.state.companies.length>0?(this.state.companies[0].recid===this.state.currentEnterprise.recid?'btn-circle disabled':'btn-circle'):'btn-circle'}
                onClick={
                  ()=>{
                    this.handleNxt('left');
                  }
                }
                >
                  <Icon type="left" />

                </div>
                <div
                className={this.state.companies.length>0?((this.state.companies.length>=this.state.total) && (this.state.companies[this.state.companies.length-1].recid===this.state.currentEnterprise.recid)?'btn-circle disabled':'btn-circle'):'btn-circle'} 
                onClick={
                  ()=>{
                    this.handleNxt('right');
                  }
                }
                >
                  <Icon type="right" />

                </div>
                
                {
                  this.state.toSub[0].jobId?<div
                  className='btn btn-sub' 
                  onClick={
                    ()=>{
                      let bol = this.vertify();
                      if(!bol){
                        this.setState({selectedTab:'personal_center',showDetail:false});
                          Toast.info('请先填写完整个人信息',1);
                      }else{
                        Antalert("确认申请职位？", <div className="memo">
                        <p>{this.state.toSub[0].job+'- 工资：'+this.state.toSub[0].salary}</p>
                        <div>
                        <span>有何建议和需求：</span><TextareaItem value={this.state.advice} onChange={(v)=>{this.setState({advice:v})}}/>
                        </div>
                        <div>
                         <span>备注：</span> <TextareaItem value={this.state.memo} onChange={(v)=>{this.setState({memo:v})}}/>
                        </div>
                      </div>, [
                          { text: "取消", onPress: () => {} },
                          {
                            text: "确认",
                            onPress: () => this.handleSubmit()
                          }
                        ]);
                      }
                    }
                  }
                  >
                    提交应聘职位
                  </div>:
                  <div
                    className='btn btn-sub' 
                  style={{backgroundColor:'#fff',color:'#000', border:'1px solid #e8e8e8',boxShadow: '0 5px 4px rgba(0,0,0,.15)'}}
                    onClick={
                      ()=>{
                        this.setState({enlargeImg:false});
                        let div;
                        if(this.state.currentEnterprise.vid) {
                          div= this.refs.videoOuter;
                        }else{
                          div= this.refs.jobs;
                        }
                        this.refs.companyDetails.scroll(0, div.offsetTop || 0);
                      }
                    }
                  >
                    {this.state.currentEnterprise.vid?'查看视频/职位':'查看职位'}
                  </div>
                }
              </footer>
          </div>
      <div className='container'
        style={this.state.isSHG?{height:'100vh'}:{}}
      >
      {this.state.canAttend?
    <>
    <div className='company_warp' style={this.state.selectedTab==='home'?{display:'block'}:{display:'none'}}>
      {/* <div className='search'>
      <form onSubmit={(e) => this.getSearchTxt(e,this.state.kw)}>
        <input type='text' value={this.state.kw} onChange={(v)=>{this.setState({kw:v.target.value})}} placeholder="输入关键字进行搜索"/>
      </form>
      </div> */}
            <ul>
              {
                this.state.companies.map(
                  item=>{
                    return(
                      <li key={item.recid}
                      >
                        <div className='logo' style={item.logo?{backgroundImage:'url('+item.logo+')',backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat:'no-repeat'}:{}}>
                        </div>
                        <div className='right'>
                          <div className='name'>
                            {item.enterpriseName}
                          </div>
                          <div className='address'>
                            工作地：{item.enterpriseAddress}
                          </div>
                          <div className='enterBtn'
                            onClick={
                              ()=>{
                                this.enterDetail(item)
                              }
                            }
                          >
                            点击进入
                          </div>
                        </div>
                        <div className='clearfix'></div>
                        <div className='bottom'>
                          <table border='1' cellSpacing={0}>
                            <tbody>
                              <tr>
                                <th>
                                  招聘岗位（工种）
                                </th>
                                <th>
                                  工资待遇（元/月，税后）
                                </th>
                                <th>
                                  招聘人数
                                </th>
                              </tr>
                          {item[692791411354]?item[692791411354].map(item2=>{
                              return(
                                <tr key={item2.recid}>
                                  <td>{item2.job}</td>
                                  <td>{item2.salary}</td>
                                  <td>{item2.number}</td>
                                </tr>
                              )
                            }):null}
                            </tbody>
                          </table>
                            
                          </div>
                      </li>
                    )
                  }
                )
              }
            </ul>
            {
             this.state.companies.length>=this.state.total && !this.state.loading?null:
             <div className='loadMore'
              onClick={()=>{
                this.getCompany();
              }}
             >点击加载更多（{this.state.companies.length}/{this.state.total?this.state.total:0}）</div>
            }
          </div>
    
    
    </>:<div className="hint" style={this.state.selectedTab!='home'?{display:'none'}:{}}><div>没有进行中的招聘会{this.state.futureJobFair.length>0?<><br/>
    近期招聘会将于以下时间举办：</>:null}</div>{this.state.futureJobFair.length>0?<ul>
      {this.state.futureJobFair.map(item=>{
        return(
          <li>{item.stTime} - {item.edTime}</li>
        )
      })}
    </ul>:null}
    </div>  
    }
          <div className='records' style={this.state.selectedTab==='records'?{display:'block'}:{display:'none'}}>
            {
              this.state.histories.length===0?<div className="emp">没有求职记录</div>:null
            }
            {
              this.state.histories.map(
                (item,key)=>{
                  return(
                    <div key={key}>
                      <span>
                        {item.date}
                      </span>
                      <ul>
                        {
                          item.children.map(
                            (item2,key)=>{
                              return(
                                <li key={'histories'+key}
                                
                                onClick={
                                  ()=>{
                                    window.location.href=window.location.origin+'/?enterpriseID='+item2.enterpriseId
                                  }
                                }
                                >
                        <div className='logo' style={item2.logo?{backgroundImage:'url('+item2.logo+')',backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat:'no-repeat'}:{}}>

                        
                                    </div>
                                    <div className='right'>
                                      <div className='name'>
                                        {item2.enterpriseName}
                                      </div>
                                      <div className='jobs'>
                                        <span className='jobName'>{item2.job}</span>
                                        <span className={item2.hired==='是'?'status success':'status'}>{item2.hired==='是'?'已录用':''}</span>
                                        {/* <span className={item2.canceled==='Y'?'cancel success':'cancel'} 
                                          onClick={()=>{
                                            if(item2.canceled!='Y'){
                                              Antalert("确认提交？", "", [
                                                { text: "取消", onPress: () => {} },
                                                {
                                                  text: "确认",
                                                  onPress: () => this.handleCancel(item2.REC_ID)
                                                }
                                              ]);
                                            }
                                          } }
                                          style={item2.hired?{display:'none'}:{}}>{item2.canceled==='Y'?'已撤销':'撤销申请'}</span> */}
                                      </div>
                                    </div>
                                </li>
                              )
                            }
                          )
                        }
                      </ul>
                    </div>
                  )
                }
              )
            }
          </div>
          <div className='personInfoWrap' style={this.state.selectedTab==='personal_center'?{display:'block'}:{display:'none'}}>
                <div className='phone'>手机号码：{this.state.userInfo.phone}</div>
                <InputItem
                  placeholder="请输入姓名"
                  value={this.state.userInfo.name}
                  onBlur={this.fixIOSWXBug}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, name: v } }
                    );
                  }}
                >
                  <span className='bitian'>*</span>姓名
                </InputItem>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "男", value: "男" },
                    { label: "女", value: "女" },
                  ]}
                  cols={1}
                  value={[this.state.userInfo.sex]}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, sex: v[0] } },
                    );
                  }}
                >
                  <List.Item arrow="horizontal"><span className='bitian'>*</span>性别</List.Item>
                </Picker>
                
                <InputItem
                  placeholder="请输入身份证号"
                  value={this.state.userInfo.ID}
                  onBlur={this.fixIOSWXBug}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, ID: v } }
                    );
                  }}
                >
                  <span className='bitian'>*</span>身份证号
                </InputItem>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={nation}
                  cols={1}
                  value={[this.state.userInfo.nation]}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, nation: v[0] } },
                    );
                  }}
                >
                  <List.Item arrow="horizontal"><span className='bitian'>*</span>民族</List.Item>
                </Picker>
                <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "本科", value: "本科" },
                            { label: "大专", value: "大专" },
                            { label: "高中", value: "高中" },
                            { label: "中专", value: "中专" },
                            { label: "初中", value: "初中" },
                            { label: "小学", value: "小学" },
                            { label: "研究生或以上", value: "研究生或以上" },
                            { label: "其他", value: "其他" },
                          ]}
                          cols={1}
                          value={[this.state.userInfo.education]}
                          onChange={(v) => {
                            this.setState(
                              { userInfo: { ...this.state.userInfo, education: v[0] } },
                            );
                          }}
                        >
                   <List.Item arrow="horizontal"><span className='bitian'>*</span>学历</List.Item>
                </Picker>
                <Picker
                          onBlur={this.fixIOSWXBug}
                          data={zhaotongTownship}
                          cols={1}
                          value={[this.state.userInfo.township_semi]}
                          onChange={(v) => {this.selectTownship(v);
                          }}
                        >
                   <List.Item arrow="horizontal"><span className='bitian'>*</span>户籍所在县、乡镇</List.Item>
                </Picker>
                {
                  this.state.userInfo.township_semi==='其他'?
                  <>
                  <InputItem
                  placeholder="请输入户籍所在县、乡镇"
                  value={this.state.userInfo.township}
                  onBlur={this.fixIOSWXBug}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, township: v } }
                    );
                  }}
                >
                  <span className='bitian'>*</span>县/乡镇
                </InputItem>
                <InputItem
                  placeholder="请输入村/社区"
                  value={this.state.userInfo.community}
                  onBlur={this.fixIOSWXBug}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, community: v } }
                    );
                  }}
                >
                  <span className='bitian'>*</span>村/社区
                </InputItem>
                </>
                  :null
                }
                
                {
                  (this.state.userInfo.township_semi!='其他'&&this.state.userInfo.township_semi)?
                  <Picker
                            onBlur={this.fixIOSWXBug}
                            data={this.state.curTownship}
                            cols={1}
                            value={[this.state.userInfo.community]}
                            onChange={(v) => {
                              this.setState(
                                {userInfo: { ...this.state.userInfo, community: v[0] } },
                              );
                            }}
                          >
                    <List.Item arrow="horizontal"><span className='bitian'>*</span>村/社区</List.Item>
                  </Picker>:null
                }
               
                <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "是", value: "是" },
                            { label: "否", value: "否" }
                          ]}
                          cols={1}
                          value={[this.state.userInfo.inFile]}
                          onChange={(v) => {
                            this.setState(
                              { userInfo: { ...this.state.userInfo, inFile: v[0] } },
                            );
                          }}
                        >
                   <List.Item arrow="horizontal"><span className='bitian'>*</span>是否建档脱贫人员</List.Item>
                </Picker>
                {this.state.isSHG?
                <div className="groupedData">

                  <InputItem
                            placeholder="请输入用工企业名称"
                            onBlur={this.fixIOSWXBug}
                            value={this.state.curExp.enterpriseName}
                            onChange={(v) => {
                              this.onChangeWkExp(v,'enterpriseName','input')
                            }}
                          >
                  <span className='bitian'>*</span>企业名称
                  </InputItem>
                  <InputItem
                            placeholder="请输入企业地址"
                            onBlur={this.fixIOSWXBug}
                            value={this.state.curExp.enterpriseAddress}
                            onChange={(v) => {
                              this.onChangeWkExp(v,'enterpriseAddress','input')
                            }}
                          >
                  <span className='bitian'>*</span>企业地址
                  </InputItem>
                  <div className='formTitle'><span className='bitian'>*</span>企业联系人（职务）</div>

                  <InputItem
                            placeholder="请输入人力资源部门联系人"
                            onBlur={this.fixIOSWXBug}
                            value={this.state.curExp.enterpriseHR}
                            onChange={(v) => {
                              this.onChangeWkExp(v,'enterpriseHR','input')
                            }}
                          >
                  
                  </InputItem>
                  <div className='formTitle'><span className='bitian'>*</span>企业联系人手机号</div>
                  <InputItem
                            placeholder="请输入联系人手机号"
                            onBlur={this.fixIOSWXBug}
                            value={this.state.curExp.enterprisePhone}
                            onChange={(v) => {
                              this.onChangeWkExp(v,'enterprisePhone','input')
                            }}
                          >
                  
                  </InputItem>
                  <InputItem
                            placeholder="请输入工作岗位（工种）"
                            onBlur={this.fixIOSWXBug}
                            value={this.state.curExp.job}
                            onChange={(v) => {
                              this.onChangeWkExp(v,'job','input')
                            }}
                          >
                  工作岗位
                  </InputItem>
                  <DatePicker
                          onBlur={this.fixIOSWXBug}
                          mode="date"
                          title="上岗（录用）日期"
                          extra="请选择"
                          minDate={new Date(-1270260000)}
                          value={this.state.curExp.enterDate}
                          onChange={(v)=>{
                            this.onChangeWkExp(v,'enterDate','date')
                          }}
                        >
                          <List.Item arrow="horizontal">上岗（录用）日期</List.Item>
                  </DatePicker>
                  <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "是", value: "是" },
                            { label: "否", value: "否" }
                          ]}
                          cols={1}
                          value={[this.state.curExp.contract]}
                          onChange={(v) => {
                            this.onChangeWkExp(v,'contract','select')
                          }}
                        >
                    <List.Item arrow="horizontal">是否已签订劳动合同</List.Item>
                  </Picker>
                  <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "是", value: "是" },
                            { label: "否", value: "否" }
                          ]}
                          cols={1}
                          value={[this.state.curExp.dispatch]}
                          onChange={(v) => {
                            this.onChangeWkExp(v,'dispatch','select')
                          }}
                        >
                    <List.Item arrow="horizontal">是否是劳务派遣用工</List.Item>
                  </Picker>
                  <InputItem
                            placeholder="平均月收入（税后）"
                            onBlur={this.fixIOSWXBug}
                            value={this.state.curExp.salary}
                            onChange={(v) => {
                              this.onChangeWkExp(v,'salary','input')
                            }}
                          >
                  税后月收入
                  </InputItem>
                  <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "是", value: "是" },
                            { label: "否", value: "否" }
                          ]}
                          cols={1}
                          value={[this.state.curExp.adapt]}
                          onChange={(v) => {
                            this.onChangeWkExp(v,'adapt','select')
                          }}
                        >
                    <List.Item arrow="horizontal">对现岗位是否适应</List.Item>
                  </Picker>
                  <div className='formTitle'>有何建议和需求</div>
                  <TextareaItem
                  clear
                  rows={4}
                  placeholder="请输入建议和需求"
                  value={
                    this.state.curExp.advice
                  }
                  onChange={(v) => {
                    this.onChangeWkExp(v,'advice','input')
                  }}
                  onBlur={this.fixIOSWXBug}
                />
                <div className='formTitle'>备注</div>
                  <TextareaItem
                  clear
                  rows={4}
                  placeholder="请输入备注"
                  value={
                    this.state.curExp.memo
                  }
                  onChange={(v) => {
                    this.onChangeWkExp(v,'memo','input')
                  }}
                  onBlur={this.fixIOSWXBug}
                />
               
                </div>:null}
                <div className='btnLine'>
                  <Button type='primary' onClick={()=>{this.subPersonInfo();}}>保存个人信息</Button>
                  <Button style={{color:'#f5222d',marginTop:8}} onClick={()=>{
                     Antalert("退出登录？", "", [
                      { text: "取消", onPress: () => {} },
                      {
                        text: "确认",
                        onPress: () => this.logOut()
                      }
                    ]);
                    }}>退出登录</Button>
                </div>
          </div>

      </div>
      {
        !this.state.isSHG?
        <footer>
          <TabBar
            unselectedTintColor="#949494"
            tintColor="#33A3F4"
            barTintColor="white"
            hidden={this.state.hidden}
            tabBarPosition="top"
          >
            <TabBar.Item
              title="企业列表"
              key="home"
              icon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/nav-home.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/nav-home-active.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selected={this.state.selectedTab === "home"}
              onPress={() => {
                if(this.state.reLoaded){
                  this.getCompany(null,'',true,null,null,null);
                  this.setState({reLoaded:false});
                }
                this.setState({
                  selectedTab: "home",
                  showDetail:false
                });
                 this.clearVideo();
              }}
            />
            <TabBar.Item
              title="求职记录"
              key="records"
              icon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/toolbar-job.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/nav-job-active.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selected={this.state.selectedTab === "records"}
              onPress={() => {
                this.getHistories();
                this.setState({
                  selectedTab: "records",
                  showDetail:false
                });
                this.clearVideo();
              }}
            />

            <TabBar.Item
              icon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/nav-user.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/nav-user-active.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              title="个人信息"
              key="personal_center"
              selected={this.state.selectedTab === "personal_center"}
              onPress={() => {
                this.setState({
                  selectedTab: "personal_center",
                  showDetail:false
                });
                this.clearVideo();
              }}
            />
            {/* <TabBar.Item
              icon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/nav-workexp.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              selectedIcon={
                <div
                  style={{
                    width: "22px",
                    height: "22px",
                    background:
                      "url(/assets/images/nav-workexp-active.svg) center center /  21px 21px no-repeat",
                  }}
                />
              }
              title="工作经历"
              key="workExp"
              selected={this.state.selectedTab === "work_exp"}
              onPress={() => {
                this.enterWkExp();
              }}
            /> */}
          </TabBar>
        </footer>
        :null
      }
        

      </div>
    );
  }
}
